// extracted by mini-css-extract-plugin
export default {"scroll":"form_scroll__uPUCn","amount":"form_amount__OT-yX","footer":"form_footer__5j8lu"};